<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>注册登录设置</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row>
        <el-col :span="24">
          <el-form ref="formParamRef" :model="formRegset" :rules="formRegsetRules" label-width="120px">
            <el-form-item label="登录开始时间" prop="LoginStartTime">
              <el-date-picker v-model="formRegset.LoginStartTime" type="datetime" placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="登录结束时间" prop="LoginEndTime">
              <el-date-picker v-model="formRegset.LoginEndTime" type="datetime" placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="注册开始时间" prop="RegStartTime">
              <el-date-picker v-model="formRegset.RegStartTime" type="datetime" placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="注册结束时间" prop="RegEndTime">
              <el-date-picker v-model="formRegset.RegEndTime" type="datetime" placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formRegset: {
        LoginStartTime: null,
        LoginEndTime: null,
        RegStartTime: null,
        RegEndTime: null
      },
      formRegsetRules: {
        LoginStartTime: [
          {
            required: true,
            message: '请选择登录开始时间',
            trigger: 'change'
          }
        ],
        LoginEndTime: [
          {
            required: true,
            message: '请选择登录结束时间',
            trigger: 'change'
          }
        ],
        RegStartTime: [
          {
            required: true,
            message: '请选择注册开始时间',
            trigger: 'change'
          }
        ],
        RegEndTime: [
          {
            required: true,
            message: '请选择注册结束时间',
            trigger: 'change'
          }
        ]
      }
    }
  },
  created() {
    this.getTime()
  },
  methods: {
    // 回填
    async getTime() {
      const { data: res } = await this.$http.get(
        '/api/GlobalSetting/GetGlobalSetting'
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.formRegset = res.Data.globalSetting
    },
    // 保存
    onSubmit() {
      this.$refs.formParamRef.validate(async (valid) => {
        if (!valid) return false
        this.formRegset.LoginStartTime = this.$moment(this.formRegset.LoginStartTime).format('YYYY-MM-DD HH:mm:ss')
        this.formRegset.LoginEndTime = this.$moment(this.formRegset.LoginEndTime).format('YYYY-MM-DD HH:mm:ss')
        this.formRegset.RegStartTime = this.$moment(this.formRegset.RegStartTime).format('YYYY-MM-DD HH:mm:ss')
        this.formRegset.RegEndTime = this.$moment(this.formRegset.RegEndTime).format('YYYY-MM-DD HH:mm:ss')
        const { data: res } = await this.$http.post(
          '/api/GlobalSetting/UpdateGlobalSetting',
          this.formRegset
        )
        if (res.StatusCode !== 1) return console.log(res.Msg)
        this.$message.success(res.Msg)
        this.getTime()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.inputtext {
  color: #999;
  margin-left: 10px;
}
</style>
